import { useState } from 'react';
import { PageTitle } from '@presentation/components/common/PagesTitle';
import './LoginPage.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '@presentation/context/AuthContext';
import { routes } from '@presentation/router/routes';
import { Form } from '@/presentation/components/Forms/Form/Form';
import { isStrongPassword } from '@/shared';


export default function NewLoginPage() {
    const navigate = useNavigate();
    const { createUser, isLoading } = useAuthContext();
    const location = useLocation();
    const user = location.state?.user;
    console.log(user)


    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmitValues = async (
        values: Record<string, unknown>
    ) => {

        setErrorMessage('');



        if (values.pass != values.passD) {
            setErrorMessage('Las contraseñas no coinsiden');
            return
        }
        try {
            await createUser({
                email: user.email,
                password: values.pass as string,
            });
            navigate(routes.login, { replace: true })
        } catch (error) {
            console.error(error);
            setErrorMessage('Error al crear Contraseña');
        }

    };

    return (
        <div className="login-container">
            <div className="login-card">

                <img
                    src="/logo.png"
                    alt="Logo"
                    className="logo"
                />

                <PageTitle title="Sistema de Incidentes" />

                <p style={{ maxWidth: 320 }}>
                    La nueva contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un carácter especial
                </p>

                <Form
                    fields={[
                        {
                            name: 'pass',
                            label: 'Nueva Contraseña Segura',
                            type: 'password',
                            validation: (value) => {
                                console.log(isStrongPassword(String(value)))
                                if (!isStrongPassword(String(value))) {
                                    return 'Escriba Contraseña Segura';
                                }

                                return null;
                            }
                        },
                        {
                            name: 'passD',
                            label: 'Repetir Contraseña',
                            type: 'password'
                        },
                    ]}



                    submitLabel={
                        isLoading
                            ? 'Creando...'
                            : 'Crear Contraseña'
                    }
                    onSubmit={handleSubmitValues}

                />

                {
                    errorMessage && (
                        <div className="error">
                            {errorMessage}
                        </div>
                    )
                }

            </div>
        </div>
    );
}
